import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { UserService } from 'src/app/services/user.service';
import { Options } from 'select2';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

declare var bootstrap: any;

@Component({
  selector: 'app-analises',
  templateUrl: './analises.component.html',
  styleUrls: ['./analises.component.css']
})
export class AnalisesComponent implements OnInit {
  isOK = false;

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  dtOptions: DataTables.Settings = {};

  cadastroFrm!: cadastroData;

  logs: Array<logsData> = [];

  modalCadastrar: any;
  modalLog: any;

  options1!: Options;

  periodos: Array<string> = [];

  constructor(public userService: UserService, private router: Router) { }

  ngOnInit(): void {
    if (this.userService.checarPermissao('24')[0]) {
      this.isOK = true;
    } else {
      return;
    }

    const today = new Date();
    for (let i = (today.getUTCFullYear() - 5); i <= today.getUTCFullYear(); i++) {
      this.periodos.push(i.toString());
    }

    this.cadastroFrm = {
      loading: false,
      data: {
        termos: '',
        cliente: -1,
        senha: '',
        instrucoes: {
          periodo: false,
          inicio: this.periodos[0],
          fim: this.periodos[this.periodos.length - 1],
          darf: true,
          dctf: true,
          mit: true,
          dirf: true,
          efd: true,
          ecd: false,
          ecf: true,
          icms: false,
          converter: false,
          dashboard: true
        }
      }
    }

    this.options1 = {
      allowClear: true,
      placeholder: 'Selecione um Cliente',
      ajax: {
        type: 'POST',
        url: environment.apiEndpoint + 'select-cliente',
        dataType: 'json',
        contentType: "application/json",
        headers: {
          Authorization: 'Bearer ' + this.userService.getToken(),
        },
        delay: 250,
        data: (params) => {
          return JSON.stringify({
            q: params.term,
          });
        },
        error: (xhr: any) => {
          if (xhr.status === 401) {
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
          }
        },
        processResults: (data) => {
          return {
            results: data,
          };
        },
        cache: true,
      },
      language: "pt-BR",
      dropdownParent: $('#cadastrar')
    };

    this.dtOptions = {
      language: this.userService.dataTableLanguage,
    }

    this.modalCadastrar = new bootstrap.Modal(
      document.getElementById('cadastrar'),
      {
        backdrop: 'static',
      }
    );

    this.modalLog = new bootstrap.Modal(
      document.getElementById('log'),
      {
        backdrop: 'static',
      }
    );

    this.dtOptions = {
      language: this.userService.dataTableLanguage,
      ajax: {
        url: environment.apiEndpoint + 'analise-list',
        type: 'POST',
        dataType: 'json',
        contentType: "application/json",
        data: function (d) {
          return JSON.stringify(d);
        },
        headers: {
          Authorization: 'Bearer ' + this.userService.getToken(),
        },
        error: (xhr: any, error: any, code: any) => {
          if (xhr.status === 401) {
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
          }
        }
      },
      pageLength: 10,
      processing: false,
      serverSide: true,
      columnDefs: [
        { "searchable": false, "targets": [8] },
        { "orderable": false, "targets": [8], },
        { "width": "5%", "targets": 0 },
        { "width": "10%", "targets": 1 },
        { "width": "5%", "targets": 2 },
        { "width": "10%", "targets": 3 },
        { "width": "10%", "targets": 5 },
        { "width": "20%", "targets": 6 },
        { "width": "5%", "targets": 7 },
        { "width": "15%", "targets": 8 },
      ],
      order: [[1, 'desc']],
      rowCallback: (row: Node, data: any[] | object, index: number) => {
        const id = Number($('button:eq(0)', row).attr('row_id'));
        $('button:eq(0)', row).off('click');
        $('button:eq(0)', row).on('click', () => {
          this.router.navigate(['/dashboard/' + id], {});
        });
        $('button:eq(1)', row).off('click');
        $('button:eq(1)', row).on('click', (obj) => {
          this.Reprocessar(Number(id));
        });
        $('button:eq(2)', row).off('click');
        $('button:eq(2)', row).on('click', (obj) => {
          const call = async () => {
            (obj.currentTarget as any).disabled = true;
            obj.currentTarget.innerHTML = '<span class="spinner-border spinner-border-sm"></span>';
            await this.fetchLog(id);
            (obj.currentTarget as any).disabled = false;
            obj.currentTarget.innerHTML = '<i class="bi bi-search"></i>';
          }
          call();
        });
        return row;
      },
    }
  }

  Reprocessar(id: number) {
    Swal.fire({
      title: 'Reprocessar Pedido?',
      icon: 'warning',
      text: 'O Pedido será recolocado na fila',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Reprocessar',
      heightAuto: false,
      allowOutsideClick: false,
      focusConfirm: false,
      customClass: {
        confirmButton: 'btn-swal',
        cancelButton: 'btn-swal-cancel',
      },
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return new Promise(() => {
          (this.userService.reprocessar_analise(id).subscribe(
            (res: any) => {
              Swal.fire({
                title: 'Sucesso',
                text: res.message,
                icon: 'success',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal',
                },
              });
              this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.ajax.reload();
              });
            },
            (err: any) => {
              switch (err.status) {
                case 400:
                  Swal.fire({
                    title: 'Erro',
                    text: String(err.error.message),
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
                case 401:
                  localStorage.removeItem('botway');
                  this.router.navigate(['/login']);
                  break;
                case 422:
                  let txt = '';
                  Object.values(err.error.errors).forEach((value: any, index) => {
                    for (let i = 0; i < Array(value).length; i++) {
                      txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                    }
                  });
                  Swal.fire({
                    title: 'Erro',
                    html: txt,
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
              }
            }
          ))
        });
      }
    });
  }

  Cadastrar() {
    let termos = '<p style="text-align: left;">Declaro estar ciente que:</p><ul style="text-align: left;"><li>Os dados colhidos e analisados devem ser auditados e confrontados com as informações constantes nos documentos oficiais do Contribuinte, tais como EFD-Contribuições, DARF pagos, ECF, ECD, etc.</li><li>TaxSuite é um sistema de análise de dados fiscais; deste modo, não se responsabiliza pela aplicação de suas funcionalidades para implementação de quaisquer correções ao Contribuinte cujas informações são analisadas, visto que qualquer procedimento de retificação de informações fiscais ou de implementação de melhorias deve ser realizado por profissional devidamente habilitado contabilmente ou juridicamente, conforme o caso.</li><li>A metodologia atual da TaxSuite não contempla resultados de Sociedades em Conta de Participação no âmbito das obrigações acessórias, tais quais ECF, SPED CONTRIBUIÇÕES E ECD. Deste modo, resultados inconsistentes podem ocorrer em empresas que sejam sócias ostensivas de SCP.</li></ul>';
    Swal.fire({
      title: 'Atenção!',
      width: 600,
      html: termos,
      icon: 'warning',
      heightAuto: false,
      allowOutsideClick: false,
      focusConfirm: false,
      customClass: {
        confirmButton: 'btn-swal',
        cancelButton: 'btn-swal-cancel'
      },
      showCancelButton: true,
      confirmButtonText: 'Eu concordo',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        this.cadastroFrm.loading = true;
        this.cadastroFrm.data.termos = termos;
        this.userService
          .cadastrarPedidoAnalise(
            this.cadastroFrm.data
          )
          .subscribe(
            (res: any) => {
              Swal.fire({
                title: 'Sucesso',
                text: res.message,
                icon: 'success',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              this.cadastroFrm.data = {
                termos: '',
                cliente: -1,
                senha: '',
                instrucoes: {
                  periodo: false,
                  inicio: this.periodos[0],
                  fim: this.periodos[this.periodos.length - 1],
                  darf: true,
                  dctf: true,
                  mit: true,
                  dirf: true,
                  efd: true,
                  ecd: false,
                  ecf: true,
                  icms: false,
                  converter: false,
                  dashboard: true
                }
              }
              this.modalCadastrar.hide();
              this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.ajax.reload();
              });
            },
            (err: any) => {
              switch (err.status) {
                case 400:
                  Swal.fire({
                    title: 'Erro',
                    text: String(err.error.message),
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
                case 401:
                  localStorage.removeItem('botway');
                  this.router.navigate(['/login']);
                  break;
                case 422:
                  let txt = '';
                  Object.values(err.error.errors).forEach((value: any, index) => {
                    for (let i = 0; i < Array(value).length; i++) {
                      txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                    }
                  });
                  Swal.fire({
                    title: 'Erro',
                    html: txt,
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
              }
              this.cadastroFrm.loading = false
            },
            () => (this.cadastroFrm.loading = false)
          );
      }
    })
  }

  fetchLog(id: number) {
    return new Promise((resolve) => {
      this.userService.fetchLogAnalise(id).subscribe(
        (res: any) => {
          this.logs = res.log;
          this.modalLog.show();
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
        },
      ).add(() => {
        resolve('');
      });
    });
  }
}

export interface cadastroData {
  loading: boolean;
  data: {
    termos: string;
    cliente: Number;
    senha: string;
    instrucoes: {
      periodo: boolean;
      inicio: string;
      fim: string;
      darf: boolean;
      dctf: boolean;
      mit: boolean;
      dirf: boolean;
      efd: boolean;
      ecd: boolean;
      ecf: boolean;
      icms: boolean;
      converter: boolean;
      dashboard: boolean
    }
  }
}

export interface logsData {
  date: string;
  log: string;
}
